import singletonSession from './IntanceSession';

const tokenService = {
    createToken (username) {
        return singletonSession
            .getInstance()
            .post('/users/client', username ? { username } : {});
    },
    deleteToken(body) {
        return singletonSession
            .getInstance()
            .post('/tokens/delete', body);
    }
}

export default tokenService
